var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import CustomerService from '../../Customer/services/CustomerService';
import Notification from '../../App/components/Notification';
import "../styles/ModalReportSubscribers.css";
function ModalReportSubscribers(props) {
    var _a = useState({}), reportInformation = _a[0], setReportInformation = _a[1];
    useEffect(function () {
        if (props.reportId !== undefined && props.reportId !== 0) {
            getCustomerReport(props.reportId);
        }
    }, []);
    function getCustomerReport(reportId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, reportInfo_1, documents_1, result_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerService.getCustomerReport(reportId)];
                    case 1:
                        response = _a.sent();
                        reportInfo_1 = JSON.parse(response.data.customer_report.data);
                        reportInfo_1 = reportInfo_1.report;
                        documents_1 = Object.keys(reportInfo_1);
                        result_1 = '';
                        documents_1.forEach(function (document, index) {
                            if (reportInfo_1[document].error) {
                                result_1 += '<p><strong>Documento:</strong> ' + document + ' <br/><strong>Erro:</strong> ' + reportInfo_1[document].error + '</p>';
                            }
                            else if (reportInfo_1[document].success) {
                                result_1 += '<p><strong>Documento:</strong> ' + document + ' <br/><strong>Sucesso:</strong> ' + reportInfo_1[document].success + '</p>';
                            }
                            if (index !== documents_1.length - 1) {
                                result_1 += '<br/>';
                            }
                        });
                        setReportInformation(result_1);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        Notification().Notify.failure("Erro");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function closeModal() {
        setReportInformation({});
        props.closeModal();
    }
    return (_jsxs(Modal, __assign({ show: props.show, onHide: closeModal, size: "lg", "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "modal-report-subscribers" }, { children: [_jsx(Modal.Header, __assign({ className: "title-modal" }, { children: _jsx(Modal.Title, __assign({ className: "modal-report-subscribers-title" }, { children: "Relat\u00F3rio de Erros" })) })), _jsxs(Modal.Body, __assign({ className: "modal-report-subscribers-body" }, { children: [_jsx("h5", __assign({ id: "modal-report-subscribers-message-error" }, { children: props.bulkActionInfo })), _jsx("hr", { id: "modal-report-subscribers-line" }), Object.values(reportInformation).length > 0 && _jsx("div", { dangerouslySetInnerHTML: { __html: reportInformation }, className: "modal-report-subscribers-information" })] })), _jsx(Modal.Footer, __assign({ className: "modal-footer" }, { children: _jsx("button", __assign({ onClick: closeModal, className: "close-button", id: "modal-report-subscribers-button-close" }, { children: "Fechar" })) }))] })));
}
export default ModalReportSubscribers;
